import apiClient from '@/services/api/apiClient';
import { QueryParams, FinancialMonthlyPayment } from '@/model';
import { buildApiUrl } from '../utils';
import {
  CreateFinancialCreditCardResponse,
  GetFinancialCreditCardsResponse,
  GetFinancialMonthlyPaymentResponse,
  GetFinancialOrdersResponse,
} from '../response/financial';
import { CreateFinancialCreditCardPayload, UpdateFinancialPaymentMethodPayload } from '../request/financial';

export class FinancialService {
  static getFinancialMonthlyPayment(params?: QueryParams) {
    return apiClient.get<GetFinancialMonthlyPaymentResponse>(buildApiUrl('/api/v1/administrator/financial/monthly-payment'), params);
  }

  static exportFinancialMonthlyPayment(params?: QueryParams) {
    return apiClient.getFile<any>(buildApiUrl('/api/v1/administrator/financial/monthly-payment/export'), params);
  }

  static getFinancialMonthlyPaymentById(id: string) {
    return apiClient.get<FinancialMonthlyPayment>(buildApiUrl('/api/v1/administrator/financial/monthly-payment/:id', { id }), false);
  }

  static exportFinancialMonthlyPaymentById(id: string) {
    return apiClient.getFile<any>(buildApiUrl('/api/v1/administrator/financial/monthly-payment/:id/export', { id }));
  }

  static getFinancialOrdersBySubscriber(subscriber_id: string, params?: QueryParams) {
    return apiClient.get<GetFinancialOrdersResponse>(buildApiUrl('/api/v1/administrator/financial/orders/:subscriber_id', { subscriber_id }), params);
  }

  static exportFinancialOrdersBySubscriber(subscriber_id: string, params?: QueryParams) {
    return apiClient.getFile<any>(buildApiUrl('/api/v1/administrator/financial/orders/:subscriber_id/export', { subscriber_id }), params);
  }

  static getFinancialCreditCardsBySubscriber(subscriber_id: string) {
    return apiClient.get<GetFinancialCreditCardsResponse>(buildApiUrl('/api/v1/administrator/financial/credit-cards/:subscriber_id', { subscriber_id }));
  }

  static createFinancialCreditCardBySubscriber(subscriber_id: string, payload: CreateFinancialCreditCardPayload) {
    return apiClient.post<CreateFinancialCreditCardResponse>(
      buildApiUrl('/api/v1/administrator/financial/credit-cards/:subscriber_id', { subscriber_id }),
      payload,
    );
  }

  static deleteFinancialCreditCardBySubscriber(subscriber_id: string, card_id: string) {
    return apiClient.delete<void>(buildApiUrl('/api/v1/administrator/financial/credit-cards/:subscriber_id/:card_id', { subscriber_id, card_id }));
  }

  static updateFinancialPaymentMethodBySubscriber(subscriber_id: string, payload: UpdateFinancialPaymentMethodPayload) {
    return apiClient.update<void>(buildApiUrl('/api/v1/administrator/financial/payment-method/:subscriber_id', { subscriber_id }), payload);
  }
}
